import React from "react";

export const Colorbar = ({ scale = [], width = 600, height = 25 }) => {
  // 1. Validate that scale has data to prevent "Cannot read property '0' of undefined"
  if (!Array.isArray(scale) || scale.length === 0) {
    return (
      <div style={{ width, color: "#666", fontSize: "12px", fontStyle: "italic" }}>
        No scale data provided.
      </div>
    );
  }

  // 2. Safely extract range values
  const min = scale[0]?.min ?? 0;
  const max = scale[scale.length - 1]?.max ?? 0;
  const range = max - min;

  // 3. Handle division by zero if range is 0
  if (range <= 0) {
    return <div style={{ width }}>Invalid scale range.</div>;
  }

  return (
    <div style={{ width, fontFamily: "sans-serif" }}>
      {/* Color segments */}
      <div
        style={{
          display: "flex",
          height,
          border: "1px solid #444",
          backgroundColor: "#eee", // Fallback background
          overflow: "hidden"
        }}
      >
        {scale.map((s, i) => {
          // Fallback to 0 if min/max are missing in a specific object
          const sMin = s.min ?? 0;
          const sMax = s.max ?? 0;
          const segmentWidth = ((sMax - sMin) / range) * 100;

          return (
            <div
              key={`seg-${i}`}
              style={{
                width: `${segmentWidth}%`,
                background: s.color || "#ccc", // Fallback color
              }}
            />
          );
        })}
      </div>

      {/* Labels */}
      <div
        style={{
          position: "relative",
          height: 18,
          marginTop: 4,
          fontSize: 12,
        }}
      >
        {scale.map((s, i) => {
          const sMin = s.min ?? 0;
          const position = ((sMin - min) / range) * 100;

          return (
            <div
              key={`lab-${i}`}
              style={{
                position: "absolute",
                left: `${position}%`,
                transform: "translateX(-50%)",
              }}
            >
              {sMin}
            </div>
          );
        })}

        <div
          style={{
            position: "absolute",
            left: "100%",
            transform: "translateX(-50%)",
          }}
        >
          {max}
        </div>
      </div>
    </div>
  );
};